import React from "react";
import { Box, Button, Menu, MenuItem, Modal, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import styles from "./View.module.css";
import moment from "moment";
// Removed material-ui-popup-state; using controlled MUI Menu
import { useSelector } from "react-redux";
import { approveProspect, rejectProspect } from "_controllers/officer";
import { toastMessage } from "utils/toastMessage";

const messageStyle = {
  position: "fixed",
  top: 0,
  right: 0,
  height: "100%",
  overflowY: "auto",
  width: "80%",
  bgcolor: "#ffffff",
  border: "none",
  boxShadow: 24,
  pt: 2,
  pb: 0,
  pl: 4,
  pr: 4,
  textAlign: "left",
  letterSpacing: 1,
};

const CustomerProspectView = ({
  handleCloseCustomer,
  data,
  remarkAction,
  setReload,
}) => {
  let user = useSelector((state) => state.user);
  console.log("inside", data);
  const locationScore = (data) => {
    if (
      data === "Main Road" ||
      data === "Transportation Hub" ||
      data === "Commercial Market"
    ) {
      return 10;
    } else if (data === "Near Main Road") {
      return 8;
    } else {
      return 6;
    }
  };

  const potentialScore = (data) => {
    if (data) {
      let sumOfSAS = data.reduce((accumulator, currentValue) => {
        currentValue.proposedBusinessByCategory.forEach((item) => {
          accumulator += parseInt(item.sas);
        });
        return accumulator;
      }, 0);
      if (sumOfSAS >= 2500000) {
        return 20;
      } else if (sumOfSAS >= 1500000 && sumOfSAS < 2500000) {
        return 16;
      } else if (sumOfSAS >= 500000 && sumOfSAS < 1500000) {
        return 12;
      } else {
        return 6;
      }
    } else {
      return 6;
    }
  };

  const jkpotentialScore = (data, jksas) => {
    let sumOfSAS = data.reduce((accumulator, currentValue) => {
      currentValue.proposedBusinessByCategory.forEach((item) => {
        accumulator += parseInt(item.sas);
      });
      return accumulator;
    }, 0);
    if (jksas >= 0.3 * sumOfSAS) {
      return 10;
    } else if (jksas >= 0.15 * sumOfSAS && jksas < 0.3 * sumOfSAS) {
      return 8;
    } else if (jksas < 0.15 * sumOfSAS) {
      return 6;
    }
  };

  const experinceScore = (data) => {
    if (parseInt(data) > 5) {
      return 10;
    } else if (parseInt(data) >= 2 && parseInt(data) <= 5) {
      return 8;
    } else {
      return 6;
    }
  };

  const industryScore = (data) => {
    if (data) {
      let compArray = [];
      data.map((n) => {
        compArray.push(n.toLowerCase());
      });
      console.log(compArray);
      if (
        compArray.includes("apollo") ||
        compArray.includes("mrf") ||
        compArray.includes("jk")
      ) {
        return 10;
      } else if (
        compArray.includes("bridgestone") ||
        compArray.includes("ceat") ||
        compArray.includes("michelin") ||
        compArray.includes("goodyear") ||
        compArray.includes("TVS") ||
        compArray.includes("continental") ||
        compArray.includes("ralco")
      ) {
        return 8;
      } else {
        return 6;
      }
    } else {
      return 6;
    }
  };

  const CustomProgessBar = ({ size, value, color, type }) => {
    const circumference = 2 * 115 * 3.14 * (value <= 50 ? 50 : value) * 0.01;
    return (
      <>
        <div
          style={{
            position: "relative",
          }}
        >
          <svg width={size} height={size} viewBox="0 0 250 250">
            <circle
              className="bg"
              cx="125"
              cy="125"
              r="115"
              fill="none"
              stroke="#ddd"
              stroke-width="20"
            ></circle>
            <circle
              className="fg"
              cx="125"
              cy="125"
              r="115"
              fill="none"
              stroke={color}
              stroke-width="20"
              stroke-dasharray={circumference}
            ></circle>
          </svg>
          <div
            style={{
              position: "absolute",
              top: 6,
              left: 5,
            }}
          >
            {Math.trunc(value)}
          </div>
          <div
            style={{ fontSize: "12px", textAlign: "center", fontWeight: "600" }}
          >
            {type}
          </div>
        </div>
      </>
    );
  };

  const rejectAction = async (prospect) => {
    await rejectProspect(prospect.prospect_id, prospect.prospectType)
      .then((d) => {
        setReload(prospect.prospect_id);
        toastMessage(d?.data?.message, "success");
      })
      .catch((err) => {
        console.log("err", err);
        toastMessage("error fetching data", "error");
      });
  };

  const approveAction = async (prospect) => {
    console.log("inside", prospect);
    await approveProspect(prospect.prospect_id, prospect.prospectType)
      .then((d) => {
        setReload(prospect.prospect_id);
        toastMessage(d?.data?.message, "success");
      })
      .catch((err) => {
        console.log("err", err);
        toastMessage("error fetching data", "error");
      });
  };
  const [menuAnchorEl, setMenuAnchorEl] = React.useState(null);
  const [menuProspect, setMenuProspect] = React.useState(null);
  const isMenuOpen = Boolean(menuAnchorEl);
  const openMenu = (event, prospect) => {
    setMenuAnchorEl(event.currentTarget);
    setMenuProspect(prospect);
  };
  const closeMenu = () => {
    setMenuAnchorEl(null);
    setMenuProspect(null);
  };

  const reputationScore = (data) => {
    if (data) {
      if (data.toLowerCase() == "highly reputed") {
        return 10;
      }
      if (data.toLowerCase() == "no negative feedback but average relations") {
        return 8;
      }
      if (data.toLowerCase() == "lack of positive feedback") {
        return 6;
      } else {
        return 6;
      }
    } else {
      return 0;
    }
  };

  return (
    <>
      <Modal open={open} onClose={handleCloseCustomer}>
        <Box sx={messageStyle} className={styles.main}>
          <div className={styles.header_div}>
            <div style={{ display: "flex" }}>
              <Typography variant="h5" style={{ textDecoration: "underline" }}>
                Customer Profile
              </Typography>
              <div style={{ display: "flex", marginLeft: "1.5rem" }}>
                <CustomProgessBar
                  size={30}
                  value={data?.jkScore || 0}
                  color={"#fdbc00"}
                  type="JK"
                />
              </div>
              <div style={{ display: "flex", marginLeft: "1.5rem" }}>
                {data?.gstin ? null : (
                  <p style={{ fontSize: "12px" }}>
                    Inclusive of 12 points,
                    <br /> 6 each for
                    <span style={{ color: "#fdbc00" }}>
                      {" "}
                      cibil and financial.
                    </span>
                  </p>
                )}
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              {/* <Button variant="contained">Action</Button> */}
              <div style={{ marginRight: "2rem" }}>
                <Button
                  variant="contained"
                  onClick={(e) => openMenu(e, data?.prosStatus)}
                  disabled={
                    !data?.prosStatus
                      ? true
                      : data?.prosStatus?.status?.includes("Pending")
                      ? false
                      : user.user.role == "ADMIN" &&
                        data?.prosStatus?.status == "Pending_HO"
                      ? false
                      : true
                  }
                >
                  {data?.prosStatus ? data?.prosStatus?.status : "N/A"}
                </Button>
                <Menu anchorEl={menuAnchorEl} open={isMenuOpen} onClose={closeMenu}>
                  <MenuItem
                    onClick={() => {
                      if (menuProspect) approveAction(menuProspect);
                      closeMenu();
                    }}
                  >
                    Approve
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      if (menuProspect) rejectAction(menuProspect);
                      closeMenu();
                    }}
                  >
                    Reject
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      if (menuProspect) remarkAction({ close: closeMenu }, menuProspect);
                      closeMenu();
                    }}
                  >
                    Remark
                  </MenuItem>
                </Menu>
              </div>

              <CloseIcon
                sx={{
                  fontSize: "40px",
                  borderRadius: "3px",
                  cursor: "pointer",
                  color: "darkgrey",
                }}
                onClick={handleCloseCustomer}
              />
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              height: "auto",
              padding: "1rem",
            }}
            className={styles.data_div}
          >
            <div
              style={{
                borderRight: "2px dashed darkgrey",
                padding: "1rem 1rem 1rem 0",
              }}
            >
              <p
                style={{
                  fontFamily: "Inter",
                  fontSize: "24px",
                  fontWeight: "400",
                  textAlign: "center",
                  textDecoration: "underline",
                  marginBottom: "2rem",
                }}
              >
                Basic
              </p>
              <p style={{ fontSize: "14px", fontWeight: "600" }}>
                Details of Contact Person
              </p>
              <p>
                <span>Designation :</span> {data?.customerDetails?.designation}
              </p>
              <p>
                <span>Name :</span> {data?.customerDetails?.name}
              </p>
              <p>
                <span>Mobile No :</span> {data?.customerDetails?.phoneNumber}
              </p>
              <p>
                <span>Email :</span> {data?.customerDetails?.email}
              </p>
              <p>
                <span>Tyre Incharge :</span>{" "}
                {data?.customerDetails?.tyreIncharge}
              </p>
              <p>
                <span>Preferred Language :</span>{" "}
                {data?.customerDetails?.preferredLanguage}
              </p>
              <p>
                <span>Date of Birth :</span>{" "}
                {data?.customerDetails?.dateOfBirth
                  ? moment
                      .utc(data?.customerDetails?.dateOfBirth)
                      .format("YYYY-MM-DD")
                  : "-"}
              </p>
              <p>
                <span>Married :</span> {data?.customerDetails?.maritalStatus}
              </p>
              <p>
                <span>Date of Anniversary :</span>{" "}
                {data?.customerDetails?.dateOfAnniversary
                  ? moment
                      .utc(data?.customerDetails?.dateOfAnniversary)
                      .format("YYYY-MM-DD")
                  : "-"}
              </p>
              <p>
                <span>Children :</span> {data?.customerDetails?.children}
              </p>
              {/* <p>
                <span>Qualification :</span>{" "}
                {data?.customerDetails?.qualification}
              </p> */}

              {/* <p>
                <span>Assosiated with JK :</span>{" "}
                {data?.basicInfo?.firstPersonContact?.assosiatedwithJK}
              </p> */}

              <p>
                <span>Smartphone User :</span>{" "}
                {data?.customerDetails?.smartPhoneUser}
              </p>
              <p>
                <span>Apps Used :</span> {data?.customerDetails?.smartPhoneUser}
              </p>
              <p>
                <span>Apps Used on Phone :</span>{" "}
                {data?.customerDetails?.appsUsedonPhone.join(", ")}
              </p>
              <p>
                <span>Apps Used to Manage Business :</span>{" "}
                {data?.customerDetails?.appsUsedManageBusiness.join(", ")}
              </p>
              <p>
                <span>Interested in JK Schemes/Offers :</span>{" "}
                {data?.customerDetails?.interestedInScheme}
              </p>

              <p
                style={{
                  fontFamily: "Inter",
                  fontSize: "24px",
                  fontWeight: "400",
                  textAlign: "center",
                  textDecoration: "underline",
                  marginBottom: "1rem",
                  marginTop: "2rem",
                }}
              >
                Address
              </p>
              <p style={{ fontSize: "14px", fontWeight: "600" }}>
                Registered Outlet
              </p>
              <p>{data?.businessDetails?.address?.address1}</p>
              <p>{data?.businessDetails?.address?.address2}</p>
              <p>{data?.businessDetails?.address?.address3}</p>
              <p>{data?.businessDetails?.address?.district}</p>
              <p>{data?.businessDetails?.address?.state}</p>
              <p>{data?.businessDetails?.address?.pincode}</p>

              <p style={{ color: "blue", fontWeight: "600" }}>
                {data?.businessDetails?.areaSelection
                  ? data?.businessDetails?.areaSelection
                  : "NA"}{" "}
                <span
                  style={{
                    color: "green",
                    fontWeight: "700",
                    marginLeft: "10px",
                  }}
                >
                  {data?.businessDetails?.areaSelection
                    ? `+
                    ${locationScore(data?.businessDetails?.areaSelection)}`
                    : "+6"}
                </span>
              </p>
            </div>
            <div
              style={{
                borderRight: "2px dashed darkgrey",
                padding: "1rem",
              }}
            >
              <p
                style={{
                  fontFamily: "Inter",
                  fontSize: "24px",
                  fontWeight: "400",
                  textAlign: "center",
                  textDecoration: "underline",
                  marginBottom: "2rem",
                }}
              >
                Vehicles
              </p>
              {data?.vehicleDetails?.vehicleDetails &&
              data?.vehicleDetails?.vehicleDetails.length > 0
                ? data?.vehicleDetails?.vehicleDetails?.map((veh, idx) => (
                    <>
                      <p>
                        <span>Vehicle Type :</span> {veh?.vehicleType}
                      </p>
                      <p>
                        <span>No of Vehicles :</span> {veh?.vehicleCount}
                      </p>
                      <p>
                        <span>Avg Running Kms/Month :</span>{" "}
                        {veh?.avgRunningKms}
                      </p>
                      <p>
                        <span>Body Type :</span> {veh?.bodyType}
                      </p>
                      <p>
                        <span>Vehicle Manufacturer :</span> {veh?.manufacturer}
                      </p>
                      <p>
                        <span>Vehicle Category :</span> {veh?.category}
                      </p>
                      <p>
                        <span>Vehicle Application :</span> {veh?.application}
                      </p>
                      <p>
                        <span>Gross Vehicle Weight(Kg) :</span>{" "}
                        {veh?.grossWeight}
                      </p>
                    </>
                  ))
                : null}

              <p
                style={{
                  fontFamily: "Inter",
                  fontSize: "24px",
                  fontWeight: "400",
                  textAlign: "center",
                  textDecoration: "underline",
                  marginBottom: "2rem",
                  marginTop: "2rem",
                }}
              >
                Tyres
              </p>
              <p>
                <span>Tyres Purchased per Month :</span>{" "}
                {data?.tyreDetails?.tyresBougthPerMonth}
              </p>
              <p>
                <span>Rear Tyre Mileage :</span>{" "}
                {data?.tyreDetails?.rearTyresMilage}
              </p>
              <p>
                <span>No of Retreaded Tyres :</span>{" "}
                {data?.tyreDetails?.retreadedTyres}
              </p>
              <p>
                <span>No of Times Tyres Retreaded :</span>{" "}
                {data?.tyreDetails?.timesRetreaded}
              </p>
              {data?.tyreDetails?.tyreDetails &&
              data?.tyreDetails?.tyreDetails.length > 0
                ? data?.tyreDetails?.tyreDetails?.map((veh, idx) => (
                    <>
                      <p
                        style={{
                          marginTop: "1rem",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Tyre {idx + 1}
                      </p>
                      <p>
                        <span>Tyre Position :</span> {veh?.tyrePosition}
                      </p>
                      <p>
                        <span>Construction :</span> {veh?.construction}
                      </p>
                      <p>
                        <span>Tyre Size :</span> {veh?.tyreSize}
                      </p>
                      <p>
                        <span>Manufacturer :</span> {veh?.manufacturer}
                      </p>
                      <p>
                        <span>Pattern :</span> {veh?.pattern}
                      </p>
                    </>
                  ))
                : null}
            </div>
            <div
              style={{
                borderRight: "2px dashed darkgrey",
                padding: "1rem",
                maxHeight: "100%",
                overflowY: "auto",
              }}
            >
              <p
                style={{
                  fontFamily: "Inter",
                  fontSize: "24px",
                  fontWeight: "400",
                  textAlign: "center",
                  textDecoration: "underline",
                  marginBottom: "2rem",
                }}
              >
                Business
              </p>
              <p>
                <span>Dealership Name:</span> {data?.businessDetails?.firmName}
              </p>
              <p>
                <span>Email:</span> {data?.businessDetails?.businessEmail}
              </p>
              <p>
                <span>Contact Number:</span>
                {data?.businessDetails?.transportContactNumber}
              </p>
              <p>
                <span>Landline Number:</span>{" "}
                {data?.businessDetails?.transportLandlineNumber}
              </p>
              <p>
                <span>Vehicles :</span> {data?.businessDetails?.noOfVehicles}
              </p>
              <p>
                <span>Drivers :</span> {data?.businessDetails?.noOfDrivers}
              </p>
              <p>
                <span>Year of Establishment :</span>{" "}
                {data?.businessDetails?.establishmentYear}
              </p>
              <p style={{ color: "blue", fontWeight: "600" }}>
                <span style={{ color: "blue" }}>GST Number :</span>{" "}
                {data?.gstin}
                <span
                  style={{
                    color: "green",
                    fontWeight: "700",
                    marginLeft: "10px",
                  }}
                >
                  {data?.gstin ? `+12` : "+0"}
                </span>
              </p>
              <p style={{ fontWeight: "600" }}>
                <span style={{}}>
                  Pan Number :{" "}
                  {data?.businessDetails?.businessPAN
                    ? data?.businessDetails?.businessPAN
                    : ""}
                </span>{" "}
                {/* <span
                  style={{
                    color: "green",
                    fontWeight: "700",
                    marginLeft: "10px",
                  }}
                >
                  {data?.businessDetails?.businessPAN ? `+6` : "+0"}
                </span> */}
              </p>
              <p>
                <span>Business Type : </span>{" "}
                {data?.businessDetails?.businessType}
              </p>
              {/* <p>
                <span>Last 3 Year Turnover</span>{" "}
                {data?.businessDetails?.dealershipName}
              </p>
              <p>
                <span>Account Type</span>{" "}
                {data?.businessDetails?.dealershipName}
              </p> */}
              <p style={{ color: "blue", fontWeight: "600" }}>
                Proposed SAS: {data?.businessDetails?.proposedSAS}
                <span
                  style={{
                    color: "green",
                    fontWeight: "700",
                    marginLeft: "10px",
                  }}
                >
                  {data?.businessDetails?.proposedSAS
                    ? `+
                    ${jkpotentialScore(
                      data?.businessDetails?.businessCouterSaleValue,
                      data?.businessDetails?.proposedSAS
                    )}`
                    : "+6"}
                </span>
              </p>
              <p>
                <span>Industry Catered : </span>{" "}
                {data?.businessDetails?.industryCatered}
              </p>
              <p>
                <span>Specialization (Current Services) : </span>{" "}
                {data?.businessDetails?.specialization}
              </p>
              <p>
                <span>Routes Catered : </span>{" "}
                {data?.businessDetails?.routesCatered}
              </p>
              <p>
                <span>Operational Hours : </span>{" "}
                {data?.businessDetails?.operationHours?.from} -
                {data?.businessDetails?.operationHours?.to}
              </p>
              <p>
                <span>Business Cycle : </span>{" "}
                {data?.businessDetails?.businessCycle}
              </p>
              <p>
                <span>Vehicle Purchase Mode : </span>{" "}
                {data?.businessDetails?.vehiclePurchaseMode}
              </p>
              <p>
                <span>Tyre Purchase Mode : </span>{" "}
                {data?.businessDetails?.tyrePurchaseMode}
              </p>
              <p>
                <span>Tyre Purchase Per Month : </span>{" "}
                {data?.businessDetails?.monthlyTyresPurchased}
              </p>
              <p>
                <span>Tyre Construction Type : </span>{" "}
                {data?.businessDetails?.tyreTypeConstruction}
              </p>
              <p>
                <span>Current JK Customer : </span>{" "}
                {data?.businessDetails?.currentJkCustomer}
              </p>
              <p>
                <span>JK Truck Wheel Service Used : </span>{" "}
                {data?.businessDetails?.truckWheelService}
              </p>
              <p>
                <span>JK Truck Service Last Used : </span>{" "}
                {data?.businessDetails?.lastDateWheelService
                  ? moment
                      .utc(data?.businessDetails?.lastDateWheelService)
                      .format("YYYY-MM-DD")
                  : "-"}
              </p>
              {/* <p>
                <span>Proposed Business Share:</span>{" "}
                {data?.businessInfo?.proposedBusinessShare}
              </p> */}
              <p style={{ color: "blue", fontWeight: "600" }}>
                <span style={{ color: "blue" }}>Experience :</span>{" "}
                {data?.businessDetails?.businessExperience}
                <span
                  style={{
                    color: "green",
                    fontWeight: "700",
                    marginLeft: "10px",
                  }}
                >
                  +
                  {data?.businessDetails?.businessExperience
                    ? experinceScore(data?.businessDetails?.businessExperience)
                    : 6}
                </span>
              </p>
              <p style={{ color: "blue", fontWeight: "600" }}>
                <span>Industry :</span>{" "}
                {data?.businessDetails?.businessCouterCompanies?.join(", ")}
                <span
                  style={{
                    color: "green",
                    fontWeight: "700",
                    marginLeft: "10px",
                  }}
                >
                  +
                  {industryScore(
                    data?.businessDetails?.businessCouterCompanies
                  )}
                </span>
              </p>
              <p>
                <span>Other Brands Used : </span>{" "}
                {data?.businessDetails?.otherBrandsUsed}
              </p>
              <p>
                <span>Other Dealer's Purchase : </span>{" "}
                {data?.businessDetails?.buyingFromJkDealer}
              </p>

              <p
                style={{
                  fontWeight: "600",
                  fontSize: "16px",
                  marginTop: "1rem",
                }}
              >
                Prospect Reputation
              </p>
              <p
                style={{
                  fontWeight: "600",
                  fontSize: "14px",
                  color: "darkgrey",
                }}
              >
                {data?.businessDetails?.optionSelection
                  ? data?.businessDetails?.optionSelection
                  : null}
                <span
                  style={{
                    color: "green",
                    fontWeight: "700",
                    marginLeft: "10px",
                  }}
                >
                  {data?.businessDetails?.optionSelection
                    ? `+
                    ${reputationScore(data?.businessDetails?.optionSelection)}`
                    : "+6"}
                </span>
              </p>
            </div>
            <div style={{ padding: "1rem" }}>
              <p
                style={{
                  fontFamily: "Inter",
                  fontSize: "24px",
                  fontWeight: "400",
                  textAlign: "center",
                  textDecoration: "underline",
                  marginBottom: "2rem",
                }}
              >
                Potential
                <span
                  style={{
                    color: "green",
                    fontWeight: "700",
                    marginLeft: "10px",
                  }}
                >
                  +
                  {potentialScore(
                    data?.businessDetails?.businessCouterSaleValue,
                    data?.businessDetails?.proposedSAS
                  )}
                </span>
              </p>
              {data?.businessDetails?.businessCouterSaleValue &&
              data?.businessDetails?.businessCouterSaleValue.length > 0 ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  {data?.businessDetails?.businessCouterSaleValue.map(
                    (p, idx) => (
                      <>
                        <p
                          style={{
                            color: "blue",
                            fontWeight: "600",
                            fontSize: "14px",
                            fontWeight: "600",
                            // marginBottom: "10px",
                            marginTop: `${idx > 0 ? "1rem" : "0"}`,
                          }}
                        >
                          {p?.companyName}
                        </p>
                        {p?.proposedBusinessByCategory &&
                        p?.proposedBusinessByCategory.length > 0 ? (
                          <>
                            {p?.proposedBusinessByCategory.map((cat) => (
                              <>
                                <p>
                                  {cat?.category} :{" "}
                                  {cat?.switchValue === true
                                    ? "Direct"
                                    : "Indirect"}{" "}
                                  {" | "}
                                  {cat?.sas}
                                </p>
                              </>
                            ))}
                          </>
                        ) : null}
                      </>
                    )
                  )}
                </div>
              ) : null}
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default CustomerProspectView;
